import Toggle from "@/components/ui/toggle";
import TagSelector from "@/components/ui/tag-selector";
// import Select from "@/components/ui/select";
import type { MinimalTag } from "@/modules/tag/types";
import type { useFormBuilderState } from "./hooks/use-form-builder-state";
// import { THEME_OPTIONS } from "./types";
import IconTag from "@/components/icons/icon-tag";
// import IconColorSwatches from "@/components/icons/icon-color-swatches";

interface TagSearchResult {
	tags: MinimalTag[];
	hasMore: boolean;
	nextCursor: string | null;
}

interface FormBuilderSettingsTabProps {
	formState: ReturnType<typeof useFormBuilderState>;
	tags: MinimalTag[];
	isLoading?: boolean;
	onCreateTag?: (label: string, onCreated: (tagId: string) => void) => void;
	hasMoreTags?: boolean;
	isLoadingMoreTags?: boolean;
	onLoadMoreTags?: () => void;
	onSearchTags?: (query: string, cursor?: string | null) => Promise<TagSearchResult | null>;
	onTagSelect?: (tag: MinimalTag) => void;
}

export default function FormBuilderSettingsTab({ formState, tags, isLoading = false, onCreateTag, hasMoreTags = false, isLoadingMoreTags = false, onLoadMoreTags, onSearchTags, onTagSelect }: FormBuilderSettingsTabProps) {
	const {
		autoApproveTestimonials,
		setAutoApproveTestimonials,
		selectedTagIds,
		setSelectedTagIds,
		// theme, setTheme
	} = formState;

	// const themeOptions = THEME_OPTIONS.map((opt) => ({
	// 	value: opt.value,
	// 	label: opt.label,
	// }));

	return (
		<div className="divide-y divide-gray-100">
			{/* Testimonials Section */}
			<div className="p-6">
				<h3 className="font-semibold text-gray-900 flex items-center gap-2 mb-8">
					<span className="text-gray-400">
						<IconTag />
					</span>
					Testimonials
				</h3>
				<div className="space-y-5">
					{/* Auto-approve testimonials */}
					<Toggle
						label="Auto-approve testimonials"
						description="Automatically approve testimonials collected with this form."
						checked={autoApproveTestimonials}
						onChange={(e) => setAutoApproveTestimonials(e.target.checked)}
						disabled={isLoading}
					/>

					{/* Auto-tag testimonials */}
					<TagSelector
						label="Auto-tag testimonials"
						description="Automatically apply tags to testimonials from this form."
						tags={tags}
						selectedTagIds={selectedTagIds}
						onChange={setSelectedTagIds}
						disabled={isLoading}
						placeholder="Select tags..."
						onCreateTag={onCreateTag}
						hasMore={hasMoreTags}
						isLoadingMore={isLoadingMoreTags}
						onLoadMore={onLoadMoreTags}
						onSearch={onSearchTags}
						onTagSelect={onTagSelect}
					/>
				</div>
			</div>

			{/* Appearance Section */}
			{/* <div className="p-6">
				<h3 className="font-semibold text-gray-900 mb-8 flex items-center gap-2">
					<span className="text-gray-400">
						<IconColorSwatches />
					</span>
					Appearance
				</h3>
				<div className="space-y-5">
					<Select label="Theme" options={themeOptions} value={theme} onChange={(value) => setTheme(value as "light" | "dark" | "system-default")} disabled={isLoading} />
				</div>
			</div> */}
		</div>
	);
}
